import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FooterSEOContent } from "@faire/retailer-visitor-shared/components/Footer/FooterSEOContent";
import { ContentContainer } from "@faire/retailer-visitor-shared/components/GiftGuide/common";
import { GiftGuideTopCarousel } from "@faire/retailer-visitor-shared/components/GiftGuide/GiftGuideTopCarousel";
import { FaireHelmet } from "@faire/retailer-visitor-shared/components/Helmet/index";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { DiscoverGifts } from "@faire/retailer-visitor-shared/views/featured/wholesale-gifts/components/DiscoverGifts";
import { ExploreCuratedCollections } from "@faire/retailer-visitor-shared/views/featured/wholesale-gifts/components/ExploreCuratedCollections";
import { GiftCarousels } from "@faire/retailer-visitor-shared/views/featured/wholesale-gifts/components/GiftCarousels";
import { SignUpBanner } from "@faire/retailer-visitor-shared/views/featured/wholesale-gifts/components/SignUpBanner";
import { TrendingOnFaire } from "@faire/retailer-visitor-shared/views/featured/wholesale-gifts/components/TrendingOnFaire";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
export var WholesaleGiftsPage = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(FaireHelmet, {
                title: strictLocalize({
                    id: "rsPLHb",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Faire | Wholesale Gift Guide"
                        }
                    ]
                }),
                description: strictLocalize({
                    id: "bidodN",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Shop unique wholesale gift ideas for any holiday or occasion. Gifts for her, gifts for him, gifts for the eco-friendly, with free returns and net 60 terms."
                        }
                    ]
                }),
                selfCanonical: true
            }),
            /*#__PURE__*/ _jsx(GiftGuideTopCarousel, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "7x"
            }),
            /*#__PURE__*/ _jsx(DiscoverGifts, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "5x",
                    tabletAndAbove: "9x"
                }
            }),
            /*#__PURE__*/ _jsx(GiftCarousels, {}),
            /*#__PURE__*/ _jsxs(ContentContainer, {
                style: {
                    padding: "0 24px"
                },
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "4x",
                            tabletAndAbove: "8x"
                        }
                    }),
                    /*#__PURE__*/ _jsx(TrendingOnFaire, {
                        clickEventPrefix: "/wholesale-gifts/trending/"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "4x",
                    tabletAndAbove: "8x"
                }
            }),
            /*#__PURE__*/ _jsx(ExploreCuratedCollections, {}),
            !isLoggedInRetailer() ? /*#__PURE__*/ _jsx(SignUpBanner, {}) : null,
            /*#__PURE__*/ _jsx(FooterSEOContent, {})
        ]
    });
};
